import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import './styles/halloween.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { GoogleOAuthProvider } from '@react-oauth/google';
import initSeasonalTheme from './utils/seasonalTheme';

// Tema stagionale: si attiva/disattiva da solo in base alla data
initSeasonalTheme();

// Sostituisci con il tuo Google Client ID da console.cloud.google.com
const GOOGLE_CLIENT_ID = '558283201307-jq90eej20q7tagj1maljdj6l5qepu037.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
